import React, { useState } from "react";
import useEventEmitter, { emitEvent } from "../../../hooks/useEventEmitter";
import CommonModal from "../../../components/CommonModal";

const EXPORT_FILTER_MODAL_EVENT = "EXPORT_FILTER_MODAL_EVENT";

export function toggleExportFilterModal() {
  emitEvent(EXPORT_FILTER_MODAL_EVENT);
}

const ExportFilterModal = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEventEmitter(EXPORT_FILTER_MODAL_EVENT, () => {
    setOpen((prev) => !prev);
  });

  return (
    <CommonModal
      open={open}
      onClose={handleClose}
      title="Export_Filter_Modal_Heading"
      description="Export_Filter_Modal_Desc"
      buttonArray={[
        {
          text: "OK",
          onClick: () => handleClose(),
          sx: {
            backgroundColor: "custom.foreground.purple",
          },
        },
      ]}
    />
  );
};

export default ExportFilterModal;
